import { Env } from "../env";

type OperatingSystem = "Windows Phone" | "Android" | "iOS" | "Desktop";

// Credits: https://stackoverflow.com/a/21742107
function getOperatingSystem(): OperatingSystem {
  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return "iOS";
  }

  return "Desktop";
}

function detectStandaloneBrowser(): boolean {
  return (
    window.matchMedia("(display-mode: standalone)").matches || // Standard PWA standalone mode
    document.referrer.startsWith("android-app://") || // Android-specific check
    ("standalone" in window.navigator && window.navigator.standalone === true) // iOS Safari standalone mode
  );
}

type BrowserName = "Safari" | "Chrome" | "Other";

function getBrowserName(): BrowserName {
  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera;

  // Detect Safari (iOS or macOS)
  const isSafari =
    /Safari/.test(userAgent) &&
    !/Chrome/.test(userAgent) &&
    !/CriOS/.test(userAgent) &&
    !/Firefox/.test(userAgent);

  if (isSafari) {
    return "Safari";
  }

  // Detect Chrome (all platforms)
  const isChrome = /Chrome/.test(userAgent) || /CriOS/.test(userAgent);

  if (isChrome) {
    return "Chrome";
  }

  return "Other";
}

const name = getBrowserName();
const OS = getOperatingSystem();
const isStandalone = detectStandaloneBrowser();
const isMobile = OS !== "Desktop";

export const browser = {
  installable: isMobile,
  installed: Env.debug || isStandalone,
  name,
  operatingSystem: OS,
};
